import { RefObject, useEffect } from 'react';

export const useClickOutside = (ref: RefObject<HTMLElement> | RefObject<HTMLElement>[], onClick: () => void): void => {
    useEffect(() => {
        const refs = Array.isArray(ref) ? ref : [ref];

        const handleClickOutside = (event: Event) => {
            const elements = refs.map((_ref) => _ref.current).filter((_current): _current is HTMLElement => !!_current);

            // Use composedPath to get the actual target through shadow DOM boundaries
            const eventPath = event.composedPath();
            const actualTarget = eventPath[0] as HTMLElement;

            if (!elements.some((element) => element.contains(actualTarget))) {
                onClick();
            }
        };

        // Get the correct document reference (works in both regular DOM and shadow DOM)
        const firstElement = refs.find((_ref) => _ref.current)?.current;
        const targetDocument = firstElement?.ownerDocument || document;

        // for more info on why we added setTimeout vide https://github.com/facebook/react/issues/24657#issuecomment-1150119055
        const timerId = setTimeout(() => targetDocument.addEventListener('mousedown', handleClickOutside), 0);

        return () => {
            targetDocument.removeEventListener('mousedown', handleClickOutside);
            clearTimeout(timerId);
        };
    }, [ref, onClick]);
};
